export function createMap<T>(items: ArrayLike<T>, keyProperty: string): { [keyProp: string]: T } {
    let result: { [keyProp: string]: T } = {};
    Array.from(items).forEach((item) => {
        result[item[keyProperty]] = item;
    });
    return result;
}
